import { WSFlexBox, WSIcon, WSText } from "@wingspanhq/fe-component-library";
import { useMemo } from "react";
import { useQueryPayee } from "../../../query/payee/queries/useQueryPayee";
import { getPayeeName } from "../../Payees/selectors/getPayeeNames";

type Props = {
  payeeId: string;
};

export const LablePayeeName: React.FC<Props> = props => {
  const queryPayee = useQueryPayee(props.payeeId);

  const name = useMemo(() => {
    if (!queryPayee.data) {
      return;
    }

    return getPayeeName(queryPayee.data);
  }, [queryPayee.data]);

  if (!name) {
    return null;
  }

  return (
    <WSFlexBox gap="XS" wrap="nowrap" alignItems="center">
      <WSIcon name="user" color="gray600" size="S" />
      <WSText.ParagraphXs color="gray600">{name}</WSText.ParagraphXs>
    </WSFlexBox>
  );
};
